module.exports = __webpack_public_path__ + "static/CircularStd-MediumItalic-dcb304fd3cf40dbdd46bd67ccc43d6fd.otf";